import styled from 'styled-components'

export const CheckoutStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1 1 auto;
  padding: 80px ${props => (props.fullwidth ? 0 : '10%')};
  align-items: center;
  overflow: hidden;
  z-index: 10;
  background: transparent;
  isolation: isolate;
`

export const CheckoutStepTitle = styled.h4`
  font-family: ${props => props.theme.font.secondary};
  font-weight: 400;
  font-size: 58px;
  margin-bottom: 3rem;
  text-align: center;
`

export const CheckoutStepContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  overflow: hidden;
`

export const CheckoutStepAction = styled.div`
  margin-top: 48px;
`

export const CheckoutStepFooter = styled.div`
  margin-top: auto;
  padding-top: 42px;
  height: 7rem;
`
